// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
import SidebarController from "./sidebar_controller";
import SidebarScrollController from "./sidebar_scroll_controller";
import AlertController from "./alert_controller";
import DropdownController from "./dropdown_controller";
import ModalController from "./modal_controller";
import FileUploadController from "./file_upload_controller";
import StockInFormController from "./stock_in_form_controller";
import StockOutFormController from "./stock_out_form_controller";
import OrderFormController from "./order_form_controller";
import CalendarController from "./calendar_controller";
import StockChartController from "./stock_chart_controller";
import InventoryCalendarController from "./inventory_calendar_controller";
import StatisticsChartController from "./statistics_chart_controller";
import DateRangeFilterController from "./date_range_filter_controller";
import CategorySortController from "./category_sort_controller";
import ColorPickerController from "./color_picker_controller";
import InfiniteScrollController from "./infinite_scroll_controller";
import AccordionController from "./accordion_controller";
import AmountCalculatorController from "./amount_calculator_controller";
import MenuSearchController from "./menu_search_controller";
import ItemSearchController from "./item_search_controller";
import PermissionToggleController from "./permission_toggle_controller";
import UserRoleToggleController from "./user_role_toggle_controller";
import HolidayCalendarController from "./holiday_calendar_controller";
import DeliveryMethodController from "./delivery_method_controller";
import TimePickerController from "./time_picker_controller";
import AddressSearchController from "./address_search_controller";
import BankSelectModalController from "./bank_select_modal_controller";
import DatePickerModalController from "./date_picker_modal_controller";
import PartnerSelectModalController from "./partner_select_modal_controller";
import UserSelectModalController from "./user_select_modal_controller";
import BulkSettlementController from "./bulk_settlement_controller";
import WorkTimePickerController from "./work_time_picker_controller";
import FilePreviewController from "./file_preview_controller";
import CountUpController from "./count_up_controller";
import OrderSelectModalController from "./order_select_modal_controller";
import RegistrationRoleController from "./registration_role_controller";

application.register("hello", HelloController);
application.register("sidebar", SidebarController);
application.register("sidebar-scroll", SidebarScrollController);
application.register("alert", AlertController);
application.register("dropdown", DropdownController);
application.register("modal", ModalController);
application.register("file-upload", FileUploadController);
application.register("stock-in-form", StockInFormController);
application.register("stock-out-form", StockOutFormController);
application.register("order-form", OrderFormController);
application.register("calendar", CalendarController);
application.register("stock-chart", StockChartController);
application.register("inventory-calendar", InventoryCalendarController);
application.register("statistics-chart", StatisticsChartController);
application.register("date-range-filter", DateRangeFilterController);
application.register("category-sort", CategorySortController);
application.register("color-picker", ColorPickerController);
application.register("infinite-scroll", InfiniteScrollController);
application.register("accordion", AccordionController);
application.register("amount-calculator", AmountCalculatorController);
application.register("menu-search", MenuSearchController);
application.register("item-search", ItemSearchController);
application.register("permission-toggle", PermissionToggleController);
application.register("user-role-toggle", UserRoleToggleController);
application.register("holiday-calendar", HolidayCalendarController);
application.register("delivery-method", DeliveryMethodController);
application.register("time-picker", TimePickerController);
application.register("address-search", AddressSearchController);
application.register("bank-select-modal", BankSelectModalController);
application.register("date-picker-modal", DatePickerModalController);
application.register("partner-select-modal", PartnerSelectModalController);
application.register("user-select-modal", UserSelectModalController);
application.register("bulk-settlement", BulkSettlementController);
application.register("work-time-picker", WorkTimePickerController);
application.register("file-preview", FilePreviewController);
application.register("count-up", CountUpController);
application.register("order-select-modal", OrderSelectModalController);
application.register("registration-role", RegistrationRoleController);
